import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';


// ----------------------------------------------------------------------

const initialState = {
    loading: false,
    error: null,
    curShopId: 0,
    tguserdata: null,
    referrer: null,
    location: null,
    filterLocation: null,
    backBtn: {},
    chat: null,
    utm: null,
};

const slice = createSlice({
    name: 'startform',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.loading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.loading = false;
            state.error = action.payload;
        },

        // HAS ERROR

        setCurShopId(state, action) {
            state.loading = false;
            state.curShopId = action.payload;
        },

        setTgUserData(state, action) {
            state.loading = false;
            state.tguserdata = action.payload;
        },

        setLocation(state, action) {
            if (state.location === null) state.location = action.payload;
            else if (state.location) {
                state.refferer = state.location;
                state.location = action.payload;
            }
        },
        setFilterLocation(state, action) {
            state.filterLocation = action.payload
        },
        setBackBtn(state, action) {
            state.backBtn = action.payload;
        },
        updateBackBtnLink(state, action) {
            if (!state.backBtn) state.backBtn = {};
            state.backBtn.link = action.payload;
        },
        setUtm(state, action) {
            state.utm = action.payload;
        },
        setChat(state, action) {
            state.chat = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;

// Actions
export const { setCurShopId, setTgUserData, setLocation, setBackBtn, setUtm, setChat, setFilterLocation, updateBackBtnLink } = slice.actions;


export function setUtmForUser(shopid, utm, tgid) {

    return async (dispatch) => {
        // dispatch(slice.actions.startLoading());
        // dispatch(slice.actions.resetDeleteItemStatus());
        try {
            const response = await axios.post(`/subscribers/${shopid}/${tgid}/set-utm`, { utm });
            // console.log("delete" , response);
            setUtm(utm)

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
}

// sendTgTrack
export function sendTgTrack(shopid, tgtrack) {

    return async (dispatch) => {
        // dispatch(slice.actions.startLoading());
        // dispatch(slice.actions.resetDeleteItemStatus());
        try {
            const response = await axios.post(`/tgtrack/${shopid}/request`, { start_value: tgtrack });
            // console.log("tgtrack response" , response);

        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    }
}

// ----------------------------------------------------------------------
// https://api.notibot.ru/subscribers/{{shop_id}}/{{user_id}}/set-utm


